function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 20.4,
  cy: 20,
  r: 20,
  fill: "#373D4C"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.315 14.9909C32.661 22.6779 26.9277 31.2491 16.7788 31.2491C13.6929 31.2491 10.8192 30.3453 8.40005 28.7944C11.3005 29.1366 14.1938 28.3309 16.4918 26.5322C14.1011 26.4858 12.0813 24.9064 11.3879 22.7368C12.2436 22.9008 13.0868 22.8509 13.8551 22.6422C11.2274 22.1128 9.41084 19.7454 9.47146 17.2139C10.2077 17.6222 11.0509 17.8682 11.9458 17.8968C9.51245 16.2709 8.82255 13.0567 10.2558 10.5983C12.9513 13.907 16.9784 16.0819 21.5208 16.3101C20.7238 12.8909 23.3178 9.60004 26.8475 9.60004C28.4163 9.60004 29.8371 10.2632 30.8354 11.3239C32.0797 11.0797 33.2491 10.6251 34.3062 9.99935C33.8981 11.274 33.0317 12.3472 31.9032 13.0228C33.0102 12.8891 34.0621 12.5968 35.0426 12.1618C34.3099 13.2581 33.3846 14.219 32.315 14.9909Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.400024 0H40.4V40H0.400024V0Z",
  fill: "white"
})));

var SvgTwitterLogo = function SvgTwitterLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitterLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter-logo.fd02f6ef.svg";
export { ForwardRef as ReactComponent };